import { gql } from "@apollo/client";

const SAVE_SITUACION_ACTUAL_VISITA_CD = gql`
mutation SaveSituacionActualVisitaCD($input: SituacionActualCDInput!) {
  saveSituacionActualVisitaCD(input: $input) {
    idVisitaCD
  }
}`;

export const adaptSituacionActualCDInput = (data) => ({
  idVisita: data?.idVisita,
  situacionActual: data?.obsSituacionActual
});

export default SAVE_SITUACION_ACTUAL_VISITA_CD;